module.exports = __webpack_public_path__ + "img/Eric_Dulan.cf691a22.jpg";